module.exports = __webpack_public_path__ + "img/sevilla_hero_card.6c26f55a.png";